import { useUpdateWindowType, usePageViewEvent } from 'common/hooks';

export const useTintingPage = () => {
	useUpdateWindowType();
	usePageViewEvent();
};
